import { render, staticRenderFns } from "./company-usage-logs.vue?vue&type=template&id=2b28fd2c"
import script from "./company-usage-logs.vue?vue&type=script&lang=js"
export * from "./company-usage-logs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports